<template>
  <div>
    <el-form ref="form" :model="form" label-width="120px" class="form" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idCode">
            <el-input v-model="form.idCode" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="form.phone" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item label="家庭电话" prop="homePhone">
            <el-input v-model="form.homePhone" style="width:100%"></el-input>
          </el-form-item>

          <el-form-item label="省">
            <el-select v-model="form.province" style="width:100%" @change="change1">
              <el-option
                v-for="(item,index) in options1"
                :key="index"
                :label="item.addressName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区">
            <el-select v-model="form.area" style="width:100%" @change="change3">
              <el-option
                v-for="(item,index) in options3"
                :key="index"
                :label="item.addressName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="社区">
            <el-select v-model="form.community" style="width:100%">
              <el-option
                v-for="(item,index) in options5"
                :key="index"
                :label="item.addressName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="form.sex" style="width:100%">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期" prop="birthDay">
            <el-date-picker
              v-model="form.birthDay"
              type="datetime"
              placeholder="选择日期时间"
              style="width:100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="年龄" prop="age">
            <el-input v-model="form.age" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item label="家政经验" prop="domestic">
            <el-input v-model="form.domestic" style="width:100%"></el-input>
          </el-form-item>

          <el-form-item label="市">
            <el-select v-model="form.city" style="width:100%" @change="change2">
              <el-option
                v-for="(item,index) in options2"
                :key="index"
                :label="item.addressName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="街道">
            <el-select v-model="form.street" style="width:100%" @change="change4">
              <el-option
                v-for="(item,index) in options4"
                :key="index"
                :label="item.addressName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="上传照片">
        <upload :fileLists="fileList" :type="typeImg" @success="successImg" @deleteImg="deleteImg" />
      </el-form-item>
      <el-form-item label="详细地址" prop="detailed">
        <el-input v-model="form.detailed" style="width:100%"></el-input>
      </el-form-item>
      <el-form-item label="员工编号" prop="staffNumber">
        <el-input type="textarea" v-model="form.staffNumber" style="width:100%"></el-input>
      </el-form-item>
      <div class="button" v-if="buttonType=='add'">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button type="danger" @click="cancel">取消</el-button>
      </div>
      <div class="button" v-if="buttonType=='compile'">
        <el-button type="primary" @click="save">编辑</el-button>
        <el-button type="danger" @click="cancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import uploadImgs from "@/component/uploadImgs/index.vue";
import request from "@/utils/request.js";
import {
  getTreeData,
  oldManOrganizationPeopleEdit,
  getCity,
  oldManOrganizationPeopleCheck,
} from "../api";
import AMap from "AMap"; // 引入高德地图
import upload from "@/component/componentsP/upImg.vue";
export default {
  components: { uploadImgs, upload },
  props: ["buttonType", "row"],
  data() {
    return {
      form: {},
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idCode: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        birthDay: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],

        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        orgId: [{ required: true, message: "请输入所在网格", trigger: "blur" }],
        rescueOrgAddress: [
          { required: true, message: "请输入组织地址", trigger: "blur" },
        ],
      },
      fileList: [], //图片上传的列表
      typeImg: "", //图片回写的标识符
      options: [],
      options1: [], //省
      options2: [], //市
      options3: [], //区
      options4: [], //街道
      options5: [], //社区
    };
  },
  methods: {
    //保存编辑按钮
    save() {
      let photo = "";
      //将上传的图片以';'去分隔 然后保存成字符串
      if (this.fileList && this.fileList.length > 0) {
        this.fileList.forEach((item) => {
          photo = photo + item.path + ";";
        });
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form = Object.assign({}, this.form, {
            state: 1,
            province: String(this.form.province),
            city: String(this.form.city),
            area: String(this.form.area),
            streetCode: String(this.form.street),
            committeeCode: String(this.form.community),
            photo,
          });
          // this.$emit('save')
          oldManOrganizationPeopleEdit(this.form).then((res) => {
            this.$message({
              message: this.form.id ? "编辑成功" : "新增成功",
              type: "success",
            });
            this.$emit("cancel");
          });
        }
      });
    },
    //取消按钮
    cancel() {
      this.$emit("cancel");
    },
    //回写拿到数据
    getHelpManageDataAPI(e) {
      oldManOrganizationPeopleCheck(e).then((res) => {
        //回写拿到对应的图片
        if (res.content.photo) {
          let arr = res.content.photo.split(";");
          arr.pop();
          this.fileList = arr.map((item) => {
            return {
              path: item,
              name: item,
            };
          });
          this.typeImg = "compile";
        }
        this.form = Object.assign({}, res.content, {
          state: 0,
          city: Number(res.content.city),
          area: Number(res.content.area),
          province: Number(res.content.province),
          community: Number(res.content.committeeCode),
          street: Number(res.content.streetCode),
        });
      });
    },
    //获取网格数据
    getTreeDataAPI() {
      getTreeData({ threeType: 1 }).then((res) => {
        console.log("res", res);
        this.options = res.content;
      });
    },

    //拿到上传图片
    successImg(e) {
      this.fileList = e;
    },
    deleteImg(e) {
      this.fileList = e;
    },
    change1(e) {
      let params = new FormData();
      params.append("id", String(e));
      this.selectAddressSheng(params, "city");
    },
    change2(e) {
      let params = new FormData();
      params.append("id", String(e));
      this.selectAddressSheng(params, "area");
    },
    change3(e) {
      let params = new FormData();
      params.append("id", String(e));
      this.selectAddressSheng(params, "street");
    },
    change4(e) {
      let params = new FormData();
      params.append("id", String(e));
      this.selectAddressSheng(params, "community");
    },
    //获取籍贯省地址查询
    async selectAddressSheng(params, type) {
      let res = await getCity(params);
      console.log("res", res.content.list);
      switch (type) {
        case "province":
          this.options1 = res.content.list;
          break;
        case "city":
          this.options2 = res.content.list;
          break;
        case "area":
          this.options3 = res.content.list;
          break;
        case "street":
          this.options4 = res.content.list;
          break;
        case "community":
          this.options5 = res.content.list;
          break;

        case "forData":
          this.form = params;
          break;
        default:
          break;
      }
    },
  },
  created() {
    // this.getTreeDataAPI();
    console.log(this.$route.query);
    console.log(this.buttonType);
    let row = JSON.parse(this.$route.query.row);
    console.log(this.row);
    //回写数据

    //拿到省 市 区 街道 社区
    new Promise((resolve) => {
      let params = new FormData();
      params.append("id", "0");
      getCity(params).then((res) => {
        console.log(0);
        this.options1 = res.content.list;
        console.log(this.options1);
        resolve();
      });
    }).then((res) => {
      new Promise((resolve) => {
        let params = new FormData();
        params.append("id", String(this.row.province));
        getCity(params).then((res) => {
          console.log("res", res);
          this.options2 = res.content.list;
          console.log(0, this.options1);
          resolve();
        });
      }).then((res) => {
        new Promise((resolve) => {
          let params = new FormData();
          params.append("id", String(this.row.city));
          getCity(params).then((res) => {
            this.options3 = res.content.list;
            console.log(2, this.options2);
            resolve();
          });
        }).then((res1) => {
          new Promise((resolve) => {
            let params = new FormData();
            params.append("id", String(this.row.area));
            getCity(params).then((res) => {
              this.options4 = res.content.list;
              console.log(3, this.options3);
              resolve();
            });
          }).then((res2) => {
            new Promise((resolve) => {
              let params = new FormData();
              params.append("id", String(this.row.streetCode));
              getCity(params).then((res) => {
                this.options5 = res.content.list;
                console.log(4, this.options4);
                resolve();
              });
            }).then((res) => {
              if (
                this.buttonType == "check" ||
                this.buttonType == "compile" ||
                this.buttonType == "audit" 
                
              ) {
                this.getHelpManageDataAPI({ id: Number(this.row.id) });
              }
            });
          });
        });
      });
    });

    //
  },
};
</script>

<style scoped>
.left {
  width: 45%;
  display: inline-block;
}
.right {
  width: 50%;
  display: inline-block;
  float: right;
}
.form {
  width: 90%;
}
.flex {
  display: flex;
}
.itemSelect {
  width: 30%;
}
.map {
  width: 100%;
  height: 120px;
  background-color: red;
}
.button {
  width: 400px;
  margin: 30px auto 0px;
  display: flex;
  justify-content: space-between;
}
.el-form-item {
  margin-bottom: 20px !important;
}
.el-form-item__label {
  line-height: 20px !important;
}
.el-radio {
  margin: 20px;
}
</style>